export { ResolvedComponent } from './resolved-component';
